import { Button, Typography } from "@mui/material";
import clsx from "clsx";
import React from "react";
import { makeStyles } from "@mui/styles";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import { useEffect } from "react";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";

const useStyles = makeStyles((theme) => ({
  root: {
    "& ul": {
      margin: "0 -10px",
    },
    "& li": {
      padding: "0 10px",

      "& img": {
        borderRadius: "8px",
      },
      "& svg": {
        margin: "0 auto 5px",
      },
      "& button": {
        height: "100%",
        minHeight: "100%",
        maxHeight: "100%",
      },
    },
  },
}));

const images = [
  {
    largeURL:
      "https://images.unsplash.com/photo-1551963831-b3b1ca40c98e?w=1200&h=1200&fit=crop&auto=format",
    thumbnailURL:
      "https://images.unsplash.com/photo-1551963831-b3b1ca40c98e?w=120&h=120&fit=crop&auto=format",
    width: 1200,
    height: 1200,
  },
  {
    largeURL:
      "https://images.unsplash.com/photo-1551782450-a2132b4ba21d?w=1200&h=1200&fit=crop&auto=format",
    thumbnailURL:
      "https://images.unsplash.com/photo-1551782450-a2132b4ba21d?w=120&h=120&fit=crop&auto=format",
    width: 1200,
    height: 1200,
  },
  {
    largeURL:
      "https://images.unsplash.com/photo-1522770179533-24471fcdba45?w=1200&h=1200&fit=crop&auto=format",
    thumbnailURL:
      "https://images.unsplash.com/photo-1522770179533-24471fcdba45?w=120&h=120&fit=crop&auto=format",
    width: 1200,
    height: 1200,
  },
];

export default function Photos(props) {
  const classes = useStyles(props);
  const { files } = props;

  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: "#my-test-gallery",
      children: "a",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, []);

  const downloadFile = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.downloadFile}`;
  const downloadPath = `${downloadFile}/${files?.fileName}?path=${files?.path}`;

  const loadFiles = async () => {
    const blob = await fetch(downloadPath, OAuthService.config()).then(resp => resp.blob());
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = files?.fileName
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(objUrl);
    document.body.removeChild(a);
  };

  return (
    <div className={clsx(classes.root, "my-24")}>
      <div className="pswp-gallery" id="my-test-gallery">
        <ul className="flex">
          {/* {images.map((image, index) => (
            <li>
              <a
                href={image.largeURL}
                data-pswp-width={image.width}
                data-pswp-height={image.height}
                key={props.galleryID + "-" + index}
                target="_blank"
                rel="noreferrer"
              >
                <img src={image.thumbnailURL} alt="" />
              </a>
            </li>
          ))} */}
          <li className="">
            <Button variant="outlined" onClick={loadFiles} sx={{ py: 4 }}>
              <div>
                <FuseSvgIcon size={34}>
                  heroicons-outline:cloud-download
                </FuseSvgIcon>
                <Typography variant="body">Download Drawings</Typography>
              </div>
            </Button>
          </li>
        </ul>
      </div>
    </div>
  );
}
